<template>
  <v-timeline-item left fill-dot icon="question_answer" color="amber">
    <span><b>{{data.question}}</b></span>
    <span slot="opposite">{{data.answer}}</span>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Ask',
  props: {
    data: Object
  }
}
</script>

<style scoped>

</style>
